import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { withServiceConsumer } from 'services/Context';
import { Img } from 'templates/Img';

const propTypes = {
	service: PropTypes.shape({
		pref: PropTypes.string.isRequired,
	}).isRequired,
};

const Logo = ({ service: { pref } }) => {
	return (
		<div className={`logo logo_${pref}`}>
			<NavLink to='/' className={`logo__link logo__link_${pref}`}>
				{/* <Img src='/assets/images/icons/logo.svg' alt='logo' /> */}
        {MilleniumLogo}
			</NavLink>
		</div>
	);
};

Logo.propTypes = propTypes;

export default withServiceConsumer(Logo);


const MilleniumLogo = (
  <svg
    width="200"
    height="38"
    viewBox="0 0 200 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_ii_424_4244)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.9172 11.3868C28.5752 12.4295 28.9351 13.6484 28.9534 14.8653C28.483 14.1346 27.7541 13.5633 26.9747 13.2693C27.146 15.2668 26.6099 17.3155 25.4786 18.9927C24.3457 20.6697 22.6234 21.9647 20.7028 22.6292C21.2628 21.8045 21.8235 20.975 22.2482 20.0778C22.6729 19.1806 22.9611 18.206 22.9436 17.2173C22.9274 16.1521 22.5466 15.0986 21.8884 14.2457C21.232 13.3929 20.2993 12.7441 19.2529 12.3949C19.9835 12.2455 20.7417 12.2249 21.5184 12.3257C19.7478 11.1268 17.4896 10.6241 15.3489 10.9751C16.4436 10.2255 17.7222 9.72703 19.0825 9.52849C18.304 9.07022 17.4562 8.72316 16.5348 8.51404C18.1658 8.02328 19.9251 7.94063 21.6871 8.20596C18.9444 7.37312 15.9315 7.405 13.1995 8.31459C14.5962 8.42731 15.9704 8.80097 17.2215 9.39205C15.7809 9.69591 14.0349 10.6233 13.032 11.626C14.0214 11.5485 15.0323 11.7363 15.9128 12.2094C14.0242 12.2568 12.1622 13.0197 10.8127 14.3022C10.453 14.6444 10.1191 15.0371 9.9842 15.507C9.85073 15.9786 9.95928 16.5411 10.3813 16.8252C9.51294 17.1283 8.53413 17.1207 7.6715 16.8057C6.80716 16.4905 6.0671 15.8688 5.62029 15.0862C5.67095 15.0865 5.72763 15.0874 5.78961 15.0885C6.80682 15.1056 9.24867 15.1467 9.83687 12.5008C9.86238 12.3855 9.88221 12.2397 9.90449 12.0761C10.0055 11.3343 10.1566 10.2241 11.1128 9.902C6.52278 9.67717 4.50957 11.3932 5.99468 12.3071C5.17036 12.409 4.34262 12.2153 3.6348 11.8183C3.70472 12.1394 3.83196 12.4454 4.0014 12.7254C3.14874 12.6122 2.32769 12.2296 1.69307 11.6532C1.05859 11.0754 0.611938 10.3056 0.432373 9.4809C0.702577 9.60011 0.996453 9.66599 1.29329 9.70331C1.17462 8.87833 1.352 8.05063 1.75069 7.33912C2.02338 8.10593 2.78541 8.61195 3.58309 8.74839C4.38249 8.88332 5.20914 8.69566 5.95216 8.38168C5.14124 8.07496 4.42392 7.53509 3.95343 6.83643C5.87289 6.61976 7.62587 5.72013 9.22093 4.68196C9.83179 4.28487 10.4268 3.86474 11.0217 3.44472C11.9816 2.76693 12.9411 2.08943 13.9661 1.50956C15.6261 0.572015 17.5141 -0.110181 19.4848 0.014775C16.9891 1.16144 14.8613 3.0462 13.4934 5.31701C16.6117 3.78067 20.3183 3.4046 23.7529 4.28518C22.2728 4.52769 20.8777 5.22832 19.8958 6.31273C23.0934 5.69641 26.5778 6.72719 28.9729 8.99105C27.7476 8.59216 26.3998 8.56088 25.1859 8.91429C26.3033 9.47939 27.2593 10.3443 27.9172 11.3868ZM7.19463 7.74239C7.68053 7.87355 8.16643 8.00455 8.65576 8.11832C9.03373 7.63436 9.43009 7.16325 9.8445 6.7083C8.97845 7.09782 8.12734 7.43779 7.19463 7.74239Z"
        fill="url(#paint0_radial_424_4244)"
      />
    </g>
    <g filter="url(#filter1_ii_424_4244)">
      <path
        d="M3.42485 18.3469C3.14681 17.4231 3.57426 16.4065 4.23723 15.7053C4.9002 15.0041 5.76816 14.5418 6.59188 14.0402C7.41559 13.5385 8.23585 12.9565 8.64865 11.9551C8.00567 12.5735 7.10938 12.858 6.2252 12.974C5.34119 13.0884 4.44584 13.0535 3.55757 13.1291C2.66915 13.2048 1.76278 13.4084 1.04596 13.9377C0.329143 14.4669 -0.156396 15.3828 0.0463844 16.2473C0.187449 15.8406 0.488628 15.4936 0.869471 15.2944C1.25031 15.0954 1.70704 15.0489 2.14866 15.1672C1.92588 15.5755 1.75742 16.0227 1.72342 16.4869C1.68941 16.9512 1.79615 17.4365 2.07734 17.808C2.3571 18.1779 2.82438 18.4187 3.42485 18.3469Z"
        fill="url(#paint1_radial_424_4244)"
      />
    </g>
    <g filter="url(#filter2_ii_424_4244)">
      <path
        d="M7.35132 5.12354C8.55803 4.52634 9.69973 3.79212 10.7723 2.88527C11.1137 2.14481 11.569 1.46129 12.1081 0.853882C9.56988 1.39111 8.56414 3.92928 7.35132 5.12354Z"
        fill="url(#paint2_radial_424_4244)"
      />
    </g>
    <g filter="url(#filter3_ii_424_4244)">
      <path
        d="M8.46164 28.1067C9.49901 27.4607 10.7747 27.1905 11.993 27.3589C10.1458 28.3409 8.9775 30.3033 8.79527 32.3187C8.61303 34.3342 9.33932 36.3675 10.5635 38C9.3354 37.7353 8.24903 37.0455 7.44869 36.1176C6.65007 35.1899 6.14047 34.0246 6.00708 32.8175C5.35751 33.4845 5.08228 34.5216 5.36596 35.414C4.31779 34.5955 3.64583 33.4041 3.45733 32.1384C3.26883 30.8726 3.56285 29.5434 4.27176 28.4673C3.17067 28.9163 2.30912 29.7301 1.85321 30.7265C1.53993 29.2948 1.83317 27.7847 2.61488 26.5639C3.39659 25.3433 4.65721 24.4255 6.07831 24.0439C5.06725 23.6636 4.06823 23.5624 3.11994 23.7343C6.7592 20.5922 10.9716 20.3485 12.2045 20.0611C17.2915 18.8789 17.4972 15.1343 15.0676 14.0973C21.988 13.8377 22.6213 20.4509 16.8224 23.7992C14.4682 25.1586 10.2413 25.3994 8.46164 28.1067Z"
        fill="url(#paint3_radial_424_4244)"
      />
    </g>
    <g filter="url(#filter4_ii_424_4244)">
      <path
        d="M25.1715 36.9013C24.9158 36.1384 24.2004 35.5364 23.3816 35.3935C24.7697 34.7157 26.4769 34.7812 27.7756 35.5412C27.606 34.7948 27.1434 34.1233 26.4898 33.7365C27.687 33.6706 28.9089 34.0446 29.845 34.7689C30.7812 35.4932 31.4222 36.5624 31.6079 37.7047C33.4833 32.4102 28.2264 28.1089 24.4359 30.887C25.1746 30.8302 26.0167 30.9098 26.7603 31.2129C27.5057 31.5161 28.1496 32.0425 28.584 32.6984C27.5613 32.039 26.2884 31.9122 25.0958 32.0442C23.9031 32.1759 22.7554 32.5423 21.5897 32.811C20.4224 33.0794 19.1959 33.2495 18.0289 32.9832C17.5142 32.8655 17.0123 32.658 16.6226 32.3147C16.246 32.9756 16.3559 33.9093 16.8976 34.5232C15.4464 33.9509 14.5962 32.4462 14.5832 30.9741C14.5701 29.5005 15.2902 28.0862 16.2896 26.8989C7.85448 30.3941 10.7471 40.1145 19.408 37.5852C21.1719 37.0686 22.9988 36.394 25.1715 36.9013Z"
        fill="url(#paint4_radial_424_4244)"
      />
    </g>
    <path
      d="M63.761 4L57.665 11.464L51.8556 4H48V16.7941H51.1088V8.16054L56.5882 15.196H58.681L64.1778 8.4641V16.7941H67.2866V4H63.761Z"
      fill="url(#paint5_linear_424_4244)"
    />
    <path
      d="M68.5023 16.7941H71.6111V4H68.5023V16.7941Z"
      fill="url(#paint6_linear_424_4244)"
    />
    <path
      d="M72.8268 4V16.7941H87.7628V13.5978H75.9356V4H72.8268Z"
      fill="url(#paint7_linear_424_4244)"
    />
    <path
      d="M88.9785 4V16.7941H103.915V13.5978H92.0873V4H88.9785Z"
      fill="url(#paint8_linear_424_4244)"
    />
    <path
      d="M105.13 4V16.7941H120.995V13.5978H108.239V11.9997H119.754V8.79445H108.239V7.1963H120.995V4H105.13Z"
      fill="url(#paint9_linear_424_4244)"
    />
    <path
      d="M135.584 4V12.58L125.572 4H122.211V16.7941H125.32V7.94627L135.645 16.7941H138.702V4H135.584Z"
      fill="url(#paint10_linear_424_4244)"
    />
    <path
      d="M153.29 4V12.58L143.278 4H139.917V16.7941H143.026V7.94627L153.351 16.7941H156.408V4H153.29Z"
      fill="url(#paint11_linear_424_4244)"
    />
    <path
      d="M157.623 16.7941H160.732V4H157.623V16.7941Z"
      fill="url(#paint12_linear_424_4244)"
    />
    <path
      d="M164.214 15.0442C165.621 16.2108 167.303 16.7941 169.26 16.7941H172.186C174.143 16.7941 175.824 16.2108 177.231 15.0442C177.926 14.4668 178.47 13.7942 178.864 13.0264C179.286 12.199 179.498 11.33 179.498 10.4193V4.01782H176.38V10.4193C176.38 11.2348 176.013 11.9461 175.277 12.5532C174.438 13.2496 173.408 13.5978 172.186 13.5978H169.26C168.032 13.5978 167.002 13.2496 166.168 12.5532C165.427 11.9461 165.057 11.2348 165.057 10.4193V4.01782H161.948V10.4193C161.948 11.33 162.156 12.199 162.573 13.0264C162.967 13.7942 163.514 14.4668 164.214 15.0442Z"
      fill="url(#paint13_linear_424_4244)"
    />
    <path
      d="M196.474 4L190.378 11.464L184.569 4H180.713V16.7941H183.822V8.16054L189.302 15.196H191.394L196.891 8.4641V16.7941H200V4H196.474Z"
      fill="url(#paint14_linear_424_4244)"
    />
    <path
      d="M54.87 31.794H57.74L54.58 27.964L57.57 24.354H54.84L52.97 26.604L51.1 24.354H48.11L51.17 27.974L48.02 31.794H50.83L52.86 29.394L54.87 31.794Z"
      fill="white"
    />
    <path
      d="M66.5459 31.794V29.904H60.3959C60.3959 29.744 60.6359 29.504 62.0859 29.204C62.4359 29.124 62.8559 29.044 63.2559 28.964C65.4959 28.564 66.3859 28.004 66.3859 26.674V26.594C66.3859 25.274 65.5659 24.254 62.6859 24.254H62.1859C58.9359 24.254 58.4759 25.934 58.4759 26.934V27.004H60.9359C60.9659 26.664 61.0559 25.944 62.4659 25.944C63.6359 25.944 63.8759 26.234 63.8759 26.594V26.604C63.8759 26.924 63.6659 27.114 62.5959 27.384L61.4659 27.694C58.6059 28.494 58.3459 29.504 58.3459 30.604V31.794H66.5459Z"
      fill="white"
    />
    <path
      d="M76.1415 29.494C78.6815 29.494 79.4315 28.414 79.4315 26.964V26.844C79.4315 25.384 78.7015 24.354 76.1415 24.354H70.9015V31.794H73.2915V29.494H76.1415ZM73.2915 26.144H75.9415C76.6915 26.144 76.9515 26.464 76.9515 26.904V26.934C76.9515 27.404 76.6915 27.714 75.9415 27.714H73.2915V26.144Z"
      fill="white"
    />
    <path
      d="M80.8038 24.354V31.794H87.6938V29.854H83.1938V24.354H80.8038Z"
      fill="white"
    />
    <path
      d="M94.4244 28.864H91.9544L93.1744 26.084L94.4244 28.864ZM95.7344 31.794H98.2844L94.7944 24.354H91.6444L88.2644 31.794H90.6544L91.2244 30.504H95.1544L95.7344 31.794Z"
      fill="white"
    />
    <path
      d="M101.114 31.794H103.494V29.114L107.164 24.354H104.544L102.394 27.144L100.254 24.354H97.3241L101.114 29.104V31.794Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_ii_424_4244"
        x="-14.5676"
        y="0"
        width="43.5405"
        height="23.6293"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-15" />
        <feGaussianBlur stdDeviation="11.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.00847942 0 0 0 0 0.00847942 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_424_4244"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4" dy="2" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0112375 0 0 0 0 0.00503381 0 0 0 0 0.000512842 0 0 0 0.253551 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_424_4244"
          result="effect2_innerShadow_424_4244"
        />
      </filter>
      <filter
        id="filter1_ii_424_4244"
        x="-15"
        y="11.9551"
        width="23.6487"
        height="7.40454"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-15" />
        <feGaussianBlur stdDeviation="11.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.00847942 0 0 0 0 0.00847942 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_424_4244"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4" dy="2" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0112375 0 0 0 0 0.00503381 0 0 0 0 0.000512842 0 0 0 0.253551 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_424_4244"
          result="effect2_innerShadow_424_4244"
        />
      </filter>
      <filter
        id="filter2_ii_424_4244"
        x="-7.64868"
        y="0.853882"
        width="19.7567"
        height="5.26965"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-15" />
        <feGaussianBlur stdDeviation="11.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.00847942 0 0 0 0 0.00847942 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_424_4244"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4" dy="2" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0112375 0 0 0 0 0.00503381 0 0 0 0 0.000512842 0 0 0 0.253551 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_424_4244"
          result="effect2_innerShadow_424_4244"
        />
      </filter>
      <filter
        id="filter3_ii_424_4244"
        x="-13.2703"
        y="14.0898"
        width="34.027"
        height="24.9102"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-15" />
        <feGaussianBlur stdDeviation="11.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.00847942 0 0 0 0 0.00847942 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_424_4244"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4" dy="2" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0112375 0 0 0 0 0.00503381 0 0 0 0 0.000512842 0 0 0 0.253551 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_424_4244"
          result="effect2_innerShadow_424_4244"
        />
      </filter>
      <filter
        id="filter4_ii_424_4244"
        x="-3.75671"
        y="26.8989"
        width="35.7567"
        height="12.1011"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-15" />
        <feGaussianBlur stdDeviation="11.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.00847942 0 0 0 0 0.00847942 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_424_4244"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4" dy="2" />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0112375 0 0 0 0 0.00503381 0 0 0 0 0.000512842 0 0 0 0.253551 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_424_4244"
          result="effect2_innerShadow_424_4244"
        />
      </filter>
      <radialGradient
        id="paint0_radial_424_4244"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-3.22959 17.1594) rotate(-11.7713) scale(52.9514 43.0162)">
        <stop stop-color="#C81A23" />
        <stop offset="0.5" stop-color="#F8B625" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_424_4244"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-1.10969 16.8115) rotate(-11.0136) scale(16.0032 12.2069)">
        <stop stop-color="#C81A23" />
        <stop offset="0.5" stop-color="#F8B625" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_424_4244"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(6.74099 4.0915) rotate(-13.274) scale(8.8768 8.06912)">
        <stop stop-color="#C81A23" />
        <stop offset="0.5" stop-color="#F8B625" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_424_4244"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-0.711574 32.2205) rotate(-18.2771) scale(36.3946 44.0852)">
        <stop stop-color="#C81A23" />
        <stop offset="0.5" stop-color="#F8B625" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_424_4244"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8.58004 35.3167) rotate(-8.00127) scale(38.0709 21.3458)">
        <stop stop-color="#C81A23" />
        <stop offset="0.5" stop-color="#F8B625" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <linearGradient
        id="paint5_linear_424_4244"
        x1="84.1628"
        y1="-18.2692"
        x2="84.1628"
        y2="20.1256"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F5AB2B" />
        <stop offset="1" stop-color="#D13624" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_424_4244"
        x1="74.3314"
        y1="-18.2692"
        x2="74.3314"
        y2="20.1256"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F5AB2B" />
        <stop offset="1" stop-color="#D13624" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_424_4244"
        x1="100.832"
        y1="-18.2692"
        x2="100.832"
        y2="20.1256"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F5AB2B" />
        <stop offset="1" stop-color="#D13624" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_424_4244"
        x1="116.984"
        y1="-18.2692"
        x2="116.984"
        y2="20.1256"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F5AB2B" />
        <stop offset="1" stop-color="#D13624" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_424_4244"
        x1="134.878"
        y1="-18.2692"
        x2="134.878"
        y2="20.1256"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F5AB2B" />
        <stop offset="1" stop-color="#D13624" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_424_4244"
        x1="153.131"
        y1="-18.2692"
        x2="153.131"
        y2="20.1256"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F5AB2B" />
        <stop offset="1" stop-color="#D13624" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_424_4244"
        x1="170.837"
        y1="-18.2692"
        x2="170.837"
        y2="20.1256"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F5AB2B" />
        <stop offset="1" stop-color="#D13624" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_424_4244"
        x1="163.452"
        y1="-18.2692"
        x2="163.452"
        y2="20.1256"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F5AB2B" />
        <stop offset="1" stop-color="#D13624" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_424_4244"
        x1="194.854"
        y1="-18.2203"
        x2="194.854"
        y2="20.1209"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F5AB2B" />
        <stop offset="1" stop-color="#D13624" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_424_4244"
        x1="216.876"
        y1="-18.2692"
        x2="216.876"
        y2="20.1256"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F5AB2B" />
        <stop offset="1" stop-color="#D13624" />
      </linearGradient>
    </defs>
  </svg>
)
